import { render } from "./cublerprivacypolicy.vue?vue&type=template&id=781a4990&scoped=true"
import script from "./cublerprivacypolicy.vue?vue&type=script&lang=js"
export * from "./cublerprivacypolicy.vue?vue&type=script&lang=js"

import "./cublerprivacypolicy.vue?vue&type=style&index=0&id=781a4990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781a4990"]])

export default __exports__